/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Page_Grow_BodyInputs */

const en_how_page_grow_body = /** @type {(inputs: How_Page_Grow_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logged sets, new bests and recovery reach your coach, so the next session is built around what you really did.`)
};

const pl_how_page_grow_body = /** @type {(inputs: How_Page_Grow_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapisane serie, rekordy i regeneracja trafiają do trenera, więc kolejny trening jest ułożony pod to, co naprawdę zrobiłeś.`)
};

/**
* | output |
* | --- |
* | "Logged sets, new bests and recovery reach your coach, so the next session is built around what you really did." |
*
* @param {How_Page_Grow_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const how_page_grow_body = /** @type {((inputs?: How_Page_Grow_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Page_Grow_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_how_page_grow_body(inputs)
	return en_how_page_grow_body(inputs)
});